import { Outlet } from 'react-router-dom';
import { useSessionStats } from '../contexts/SessionStatsContext';
import NoSessionIdScreen from './NoSessionIdScreen';
import DashboardSkeleton from './SkeletonLoader';
import './AdminLayout.css';
import logos from '../assets/images/loghi/logos.svg';
import group from '../assets/images/icons/group.svg';

function AdminLayout() {
  const { showNoSessionIdScreen, showNoValidSessionIdScreen, sessionId, aggregated, loading } = useSessionStats();

  if (loading && sessionId) {
    return (
      <div className='admin-layout'>
        <header className='admin-header'>
          <div className='sponsor-logos'>
            <img src={logos} alt='Sponsor' className='sponsor-logo' />
          </div>
          <div className='participants-counter'>
            <span className='participant-icon'>
              <img src={group} alt='Group' className='participant-icon' />
            </span>
            <span className='participant-count'>-- partecipanti</span>
          </div>
        </header>
        <main className='admin-main'>
          <DashboardSkeleton />
        </main>
      </div>
    );
  }
  // Show appropriate error screen if needed
  if (showNoSessionIdScreen || showNoValidSessionIdScreen) {
    return (
      <div className='admin-layout'>
        <header className='admin-header'>
          <div className='sponsor-logos'>
            <img src={logos} alt='Sponsor' className='sponsor-logo' />
          </div>
          <div className='participants-counter'>
            <span className='participant-icon'>
              <img src={group} alt='Group' className='participant-icon' />
            </span>
            <span className='participant-count'>-- partecipanti</span>
          </div>
        </header>
        <main className='admin-main'>
          <NoSessionIdScreen />
        </main>
      </div>
    );
  }


  const participantCount = aggregated?.total_participants

  return (
    <div className='admin-layout'>
      {/* Top Header with logos and participant count */}
      <header className='admin-header'>
        <div className='sponsor-logos'>
          <img src={logos} alt='Sponsor' className='sponsor-logo' />
        </div>

        <div className='participants-counter'>
          <span className='participant-icon'>
            <img src={group} alt='Group' className='participant-icon' />
          </span>
          <span className='participant-count'>{participantCount ? participantCount : '--'} partecipanti</span>
        </div>
      </header>

      {/* Main Content Area */}
      <main className='admin-main'>
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
